import Vue from 'vue';

export default filter => Vue.$http
    .get('Products', { params: filter });




// WEBPACK FOOTER //
// ./src/services/product/get.js